// containers/TotalExpenses.jsx
import React, { useEffect, useState } from "react";
import TotalProfitBox from "../../components/ActividadDatos/TotalProfitBox";
import { getUser } from "../../../auth";

const URL = process.env.REACT_APP_API_URL;

export default function TotalProfit() {
  const [total, setTotal] = useState(null);

  useEffect(() => {
    const fetchTotal = async () => {
      const user = getUser();
      try {
        const res = await fetch(`${URL}/api/activity/datos/summary/total-profit/`, {
          headers: {
            "x-empresa-id": user?.empresa_id,
          },
        });
        if (!res.ok) throw new Error("Error al obtener la ganancia totales");
        const data = await res.json();
        setTotal(data.profit);
      } catch (err) {
        console.error(err);
      }
    };

    fetchTotal();
  }, []);

  return <TotalProfitBox total={total} />;
}
